import {
  TrackOlciFlowEventInterface,
  TrackOlciFlowParamsInterface,
  GlobalAnalyticsVariablesInterface
} from '../interfaces';
import {analyticsConstants} from '../../constants';
import {TelemetryGenericEnum} from '../../shared/enums';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackOlciCompletePayloadCase = (
  payload: TrackOlciFlowParamsInterface,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackOlciFlowEventInterface => {
  const data = retrieveTrackOlciCompletePayload(payload);
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}

const retrieveTrackOlciCompletePayload = (
  payload: TrackOlciFlowParamsInterface,
): TrackOlciFlowEventInterface => ({
  eventType: TelemetryGenericEnum.INTERACTION_EVENT_TYPE,
  olciPassengerIds: payload.olciPassengerIds ?? TelemetryGenericEnum.EMPTY_VALUE,
  fluidVariable: analyticsConstants.FLOW_EVENTS.COMPLETE_FLUID_VARIABLE,
  interaction: analyticsConstants.FLOW_EVENTS.COMPLETE_INTERACTION,
  pageName: analyticsConstants.FLOW_EVENTS.COMPLETE_PAGE_NAME,
})
